(function () {
  var header = document.querySelector(".header-area");

  function normalizeTopChromeOrder() {
    if (!header) return;
    var bar = document.querySelector(".km-trust-bar");
    var headerSection = header.closest(".shopify-section") || header;
    var wrapper = headerSection.parentElement;
    if (!bar || !wrapper || bar.parentElement !== wrapper) return;
    if (bar.nextElementSibling !== headerSection) {
      wrapper.insertBefore(bar, headerSection);
    }
  }

  function syncHeaderOffset() {
    var bar = document.querySelector(".km-trust-bar");
    var height = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--km-trust-height", height + "px");
    if (header && document.body.classList.contains("kmu-experience")) document.documentElement.style.setProperty("--kmu-header-height", Math.ceil(header.getBoundingClientRect().height) + "px");
  }

  function getScrollTop() {
    return document.body.scrollTop
      || document.documentElement.scrollTop
      || window.pageYOffset
      || 0;
  }

  function syncHeaderState() {
    if (!header) return;
    var y = getScrollTop();
    var isHome = document.body.classList.contains("template-index");
    var hero = document.querySelector(".ksz-hero, .km-hero-main, .slider-height, .hero-area, .km-hero-section");
    var solidAt = hero ? hero.offsetTop + hero.offsetHeight : window.innerHeight;

    header.classList.toggle("km-scrolled", y > 60);
    if (isHome) document.body.classList.toggle("km-home-header-is-scrolled", y > 24);

    var shouldForcePurpleHeader = !isHome || y > 24 || document.body.classList.contains("kmu-experience");
    if (shouldForcePurpleHeader) {
      header.style.setProperty("background", "#2e1065", "important");
      header.style.setProperty("background-color", "#2e1065", "important");
      header.style.setProperty("background-image", "none", "important");
      header.style.setProperty("border-bottom-color", "rgba(255, 255, 255, .12)", "important");
      header.dataset.kmForcedScrollBackground = "true";
    } else if (isHome && header.dataset.kmForcedScrollBackground === "true") {
      header.style.removeProperty("background");
      header.style.removeProperty("background-color");
      header.style.removeProperty("background-image");
      header.style.removeProperty("border-bottom-color");
      delete header.dataset.kmForcedScrollBackground;
    }

    if (header.classList.contains("transparent_enable")) {
      header.classList.toggle("hdr-solid", y > solidAt);
      header.classList.toggle("hdr-glass", y > 80 && y <= solidAt);
    }
  }

  function syncHeaderControlsAppearance() {
    var controls = document.querySelectorAll(
      ".header-area .header-search > a.search-active, "
      + ".header-area .cart-wrap > button.icon-cart-active, "
      + ".header-area .setting-wrap > button.km-account-btn, "
      + ".header-area .setting-wrap > button.setting-active",
    );

    controls.forEach(function (control) {
      control.style.setProperty("background", "#fff", "important");
      control.style.setProperty("background-color", "#fff", "important");
      control.style.setProperty("background-image", "none", "important");
      control.style.setProperty("border-color", "#c4b5fd", "important");
      control.style.setProperty("color", "#2e1065", "important");
      control.style.setProperty(
        "box-shadow",
        "inset 0 0 0 24px #fff, 0 7px 18px rgba(15, 7, 35, .22)",
        "important",
      );

      control.querySelectorAll("svg, svg path, svg circle, svg line, svg polyline").forEach(function (icon) {
        icon.style.setProperty("color", "#2e1065", "important");
        icon.style.setProperty("stroke", "currentColor", "important");
      });

      if (control.classList.contains("km-account-btn") || control.classList.contains("setting-active")) {
        control.querySelectorAll("svg, svg path").forEach(function (icon) {
          icon.style.setProperty("fill", "currentColor", "important");
        });
      }
    });

    document.querySelectorAll(".header-area .cart-wrap .count-style, .header-area .cart-wrap .bigcounter").forEach(function (badge) {
      badge.style.setProperty("top", "-7px", "important");
      badge.style.setProperty("right", "-9px", "important");
      badge.style.setProperty("bottom", "auto", "important");
      badge.style.setProperty("left", "auto", "important");
      badge.style.setProperty("width", "auto", "important");
      badge.style.setProperty("min-width", "19px", "important");
      badge.style.setProperty("max-width", "32px", "important");
      badge.style.setProperty("height", "19px", "important");
      badge.style.setProperty("padding", "0 5px", "important");
      badge.style.setProperty("border", "2px solid #fff", "important");
      badge.style.setProperty("border-radius", "999px", "important");
      badge.style.setProperty("background", "#7c3aed", "important");
      badge.style.setProperty("color", "#fff", "important");
      badge.style.setProperty("font-size", "10px", "important");
      badge.style.setProperty("font-weight", "800", "important");
      badge.style.setProperty("line-height", "15px", "important");
    });
  }

  function positionDesktopMenus() {
    if (!header || window.innerWidth < 992) return;
    var headerRect = header.getBoundingClientRect();
    var chromeBottom = headerRect.bottom;
    var topChrome = [
      document.querySelector(".km-trust-bar"),
      document.querySelector(".km-breadcrumb-bar"),
      document.querySelector('.wrapper > div[style*="background:rgba(30,27,75"]'),
    ];

    topChrome.forEach(function (element) {
      if (!element) return;
      var rect = element.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < 280) chromeBottom = Math.max(chromeBottom, rect.bottom);
    });

    var menuTop = Math.round(chromeBottom);
    var maxHeight = Math.max(240, Math.round(window.innerHeight - menuTop - 16));
    document.documentElement.style.setProperty("--km-menu-top", menuTop + "px");
    document.documentElement.style.setProperty("--km-menu-max-height", maxHeight + "px");

    document.querySelectorAll(".km-mega-dropdown").forEach(function (panel) {
      var parent = panel.closest(".km-mega-parent");
      var trigger = parent && parent.querySelector(".km-mega-trigger");
      var panelWidth = panel.offsetWidth || 700;
      var triggerRect = trigger && trigger.getBoundingClientRect();
      var left = triggerRect
        ? triggerRect.left + (triggerRect.width / 2) - (panelWidth / 2)
        : 16;
      left = Math.max(16, Math.min(window.innerWidth - panelWidth - 16, left));

      if (parent) {
        parent.style.setProperty("--km-menu-bridge-left", Math.round(triggerRect.left) + "px");
        parent.style.setProperty("--km-menu-bridge-width", Math.round(triggerRect.width) + "px");
        parent.style.setProperty("--km-menu-bridge-top", Math.round(triggerRect.bottom) + "px");
        parent.style.setProperty(
          "--km-menu-bridge-height",
          Math.max(1, Math.round(menuTop - triggerRect.bottom)) + "px",
        );
      }
      panel.style.setProperty("top", menuTop + "px", "important");
      panel.style.setProperty("left", Math.round(left) + "px", "important");
      panel.style.setProperty("max-height", maxHeight + "px", "important");
    });

    document.querySelectorAll(".km-more-menu__panel").forEach(function (panel) {
      var parent = panel.closest(".km-more-menu");
      if (!parent) return;
      var triggerRect = parent.getBoundingClientRect();
      var panelWidth = panel.offsetWidth || 620;
      var left = Math.max(16, Math.min(
        window.innerWidth - panelWidth - 16,
        triggerRect.right - panelWidth,
      ));
      parent.style.setProperty("--km-menu-bridge-left", Math.round(triggerRect.left) + "px");
      parent.style.setProperty("--km-menu-bridge-width", Math.round(triggerRect.width) + "px");
      parent.style.setProperty("--km-menu-bridge-top", Math.round(triggerRect.bottom) + "px");
      parent.style.setProperty(
        "--km-menu-bridge-height",
        Math.max(1, Math.round(menuTop - triggerRect.bottom)) + "px",
      );
      panel.style.setProperty("top", menuTop + "px", "important");
      panel.style.setProperty("left", Math.round(left) + "px", "important");
      panel.style.setProperty("max-height", maxHeight + "px", "important");
    });

    document.querySelectorAll(".main-menu .disturb_menu").forEach(function (panel) {
      var parent = panel.closest(".drop_arrow");
      if (!parent) return;
      var triggerRect = parent.getBoundingClientRect();
      var panelWidth = panel.offsetWidth || 280;
      var left = Math.max(16, Math.min(
        window.innerWidth - panelWidth - 16,
        triggerRect.left,
      ));
      parent.style.setProperty("--km-menu-bridge-left", Math.round(triggerRect.left) + "px");
      parent.style.setProperty("--km-menu-bridge-width", Math.round(triggerRect.width) + "px");
      parent.style.setProperty("--km-menu-bridge-top", Math.round(triggerRect.bottom) + "px");
      parent.style.setProperty(
        "--km-menu-bridge-height",
        Math.max(1, Math.round(menuTop - triggerRect.bottom)) + "px",
      );
      panel.style.setProperty("top", menuTop + "px", "important");
      panel.style.setProperty("left", Math.round(left) + "px", "important");
      panel.style.setProperty("max-height", maxHeight + "px", "important");
    });

    document.querySelectorAll(".km-account-dropdown").forEach(function (panel) {
      var parent = panel.closest(".setting-wrap");
      var trigger = parent && parent.querySelector(".km-account-btn, .setting-active");
      if (!trigger) return;
      var triggerRect = trigger.getBoundingClientRect();
      var panelWidth = panel.offsetWidth || 300;
      var left = Math.max(16, Math.min(
        window.innerWidth - panelWidth - 16,
        triggerRect.right - panelWidth,
      ));
      panel.style.setProperty("position", "fixed", "important");
      panel.style.setProperty("top", menuTop + "px", "important");
      panel.style.setProperty("left", Math.round(left) + "px", "important");
      panel.style.setProperty("right", "auto", "important");
      panel.style.setProperty("max-height", maxHeight + "px", "important");
    });
  }

  function accountPanelIsOpen() {
    var panel = document.querySelector(".km-account-dropdown");
    if (!panel) return false;
    return panel.classList.contains("show")
      || panel.matches(":hover")
      || panel.contains(document.activeElement);
  }

  function syncAccountOverlay() {
    if (!header) return;
    var isOpen = window.innerWidth >= 992 && accountPanelIsOpen();
    header.classList.toggle("km-overlay-active", isOpen);
    if (isOpen) requestAnimationFrame(positionDesktopMenus);
  }

  var lastSearchTrigger = null;

  function closeSearch() {
    var panel = document.querySelector(".main-search-active");
    if (!panel) return;
    panel.classList.remove("inside");
    document.body.classList.remove("km-search-open");
    if (header) header.classList.remove("km-search-active");
    if (lastSearchTrigger) {
      lastSearchTrigger.setAttribute("aria-expanded", "false");
      lastSearchTrigger.focus();
    }
  }

  function openSearch(trigger) {
    var panel = document.querySelector(".main-search-active");
    lastSearchTrigger = trigger;
    trigger.setAttribute("aria-expanded", "true");
    if (document.getElementById("km-spot")) {
      if (panel) panel.classList.remove("inside");
      document.body.classList.add("km-search-open");
      if (header) header.classList.remove("km-search-active");
      return;
    }
    if (!panel) return;
    panel.classList.add("inside");
    document.body.classList.add("km-search-open");
    if (header) header.classList.add("km-search-active");
    window.setTimeout(function () {
      var input = panel.querySelector('input[type="search"], input[name="q"]');
      if (input) input.focus();
    }, 80);
  }

  function syncAll() {
    normalizeTopChromeOrder();
    syncHeaderOffset();
    syncHeaderState();
    syncHeaderControlsAppearance();
    positionDesktopMenus();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAll);
  } else {
    syncAll();
  }

  window.addEventListener("load", syncAll);
  window.addEventListener("resize", syncAll, { passive: true });
  var headerSettleTimer = null;
  window.addEventListener("scroll", function () {
    syncHeaderState();
    requestAnimationFrame(positionDesktopMenus);
    if (headerSettleTimer) window.clearTimeout(headerSettleTimer);
    headerSettleTimer = window.setTimeout(function () {
      syncHeaderState();
      syncHeaderControlsAppearance();
    }, 120);
  }, { passive: true });
  document.addEventListener("scroll", syncHeaderState, { passive: true });
  document.body.addEventListener("scroll", syncHeaderState, { passive: true });
  document.addEventListener("click", function () {
    requestAnimationFrame(function () {
      positionDesktopMenus();
      syncAccountOverlay();
    });
  });
  document.addEventListener("focusin", syncAccountOverlay);
  document.addEventListener("focusout", function () {
    window.setTimeout(syncAccountOverlay, 0);
  });

  document.querySelectorAll(".km-account-dropdown").forEach(function (panel) {
    if (window.MutationObserver) {
      new MutationObserver(syncAccountOverlay).observe(panel, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
    var parent = panel.closest(".setting-wrap");
    if (!parent) return;
    parent.addEventListener("mouseenter", syncAccountOverlay);
    parent.addEventListener("mouseleave", function () {
      window.setTimeout(syncAccountOverlay, 160);
    });
  });

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest && event.target.closest("a.search-active");
    if (trigger) {
      event.preventDefault();
      openSearch(trigger);
      return;
    }
    var closeButton = event.target.closest
      && event.target.closest(".main-search-active .search-close");
    if (closeButton) {
      event.preventDefault();
      closeSearch();
      return;
    }
    var spotlightClose = event.target.closest
      && event.target.closest(".km-spot-close, .km-spot-backdrop");
    if (spotlightClose) {
      closeSearch();
    }
  }, true);

  document.querySelectorAll(".main-search-active").forEach(function (panel) {
    panel.addEventListener("click", function (event) {
      if (event.target === panel) closeSearch();
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeSearch();
      var servicesMenu = document.querySelector(".km-more-menu");
      if (servicesMenu) {
        servicesMenu.classList.remove("km-more-open");
        var trigger = servicesMenu.querySelector(".km-more-menu__trigger");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
      }
    }
  });

  var menuCloseTimers = new WeakMap();

  function cancelMenuClose(item) {
    var timer = menuCloseTimers.get(item);
    if (timer) window.clearTimeout(timer);
  }

  function openDesktopMenu(item) {
    cancelMenuClose(item);
    document.querySelectorAll(".km-mega-open, .km-more-open, .km-submenu-open").forEach(function (menu) {
      if (menu !== item) menu.classList.remove("km-mega-open", "km-more-open", "km-submenu-open");
    });

    var hasMenu = item.classList.contains("km-mega-parent")
      || item.classList.contains("km-more-menu")
      || item.classList.contains("drop_arrow");

    if (!hasMenu) {
      if (header) header.classList.remove("km-menu-active");
      return;
    }

    if (header) header.classList.add("km-menu-active");
    positionDesktopMenus();
    if (item.classList.contains("km-mega-parent")) item.classList.add("km-mega-open");
    if (item.classList.contains("km-more-menu")) item.classList.add("km-more-open");
    if (item.classList.contains("drop_arrow")) item.classList.add("km-submenu-open");
    requestAnimationFrame(positionDesktopMenus);
  }

  function scheduleMenuClose(item) {
    cancelMenuClose(item);
    menuCloseTimers.set(item, window.setTimeout(function () {
      item.classList.remove("km-mega-open", "km-more-open", "km-submenu-open");
      if (item.classList.contains("km-more-menu")) {
        var servicesTrigger = item.querySelector(".km-more-menu__trigger");
        if (servicesTrigger) servicesTrigger.setAttribute("aria-expanded", "false");
        if (!item.matches(":hover")) {
          var active = document.activeElement;
          if (active && active.closest(".km-more-menu") === item) active.blur();
        }
      }
      if (
        header
        && !document.querySelector(".km-mega-open, .km-more-open, .km-submenu-open")
      ) {
        header.classList.remove("km-menu-active");
      }
    }, 320));
  }

  document.querySelectorAll(".main-menu > nav > ul > li").forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      if (item.classList.contains("km-more-menu")) {
        cancelMenuClose(item);
        return;
      }
      var active = document.activeElement;
      if (
        !item.classList.contains("km-more-menu")
        && active
        && active.closest(".km-more-menu")
      ) {
        active.blur();
      }
      if (item.classList.contains("km-mega-parent")) {
        document.querySelectorAll(".km-more-menu.km-more-open").forEach(function (menu) {
          menu.classList.remove("km-more-open");
        });
        if (document.activeElement && document.activeElement.closest(".km-more-menu")) {
          document.activeElement.blur();
        }
      }
      openDesktopMenu(item);
    });
    item.addEventListener("mouseleave", function () {
      scheduleMenuClose(item);
    });

    var panel = item.querySelector(".km-mega-dropdown, .km-more-menu__panel, .disturb_menu");
    if (panel) {
      panel.addEventListener("mouseenter", function () {
        cancelMenuClose(item);
      });
      panel.addEventListener("mouseleave", function () {
        scheduleMenuClose(item);
      });
    }
  });

  document.addEventListener("click", function (event) {
    if (window.innerWidth < 992) return;
    var servicesMenu = document.querySelector(".km-more-menu");
    if (!servicesMenu) return;
    var trigger = event.target.closest && event.target.closest(".km-more-menu__trigger");

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      var shouldOpen = !servicesMenu.classList.contains("km-more-open");
      document.querySelectorAll(".km-mega-open, .km-submenu-open").forEach(function (menu) {
        menu.classList.remove("km-mega-open", "km-submenu-open");
      });
      servicesMenu.classList.toggle("km-more-open", shouldOpen);
      trigger.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
      if (header) header.classList.toggle("km-menu-active", shouldOpen);
      if (shouldOpen) positionDesktopMenus();
      return;
    }

    if (!servicesMenu.contains(event.target)) {
      servicesMenu.classList.remove("km-more-open");
      var servicesTrigger = servicesMenu.querySelector(".km-more-menu__trigger");
      if (servicesTrigger) servicesTrigger.setAttribute("aria-expanded", "false");
    }
  }, true);

  document.addEventListener("pointerover", function (event) {
    if (window.innerWidth < 992) return;
    var servicesMenu = document.querySelector(".km-more-menu");
    if (!servicesMenu || servicesMenu.contains(event.target)) return;

    servicesMenu.classList.remove("km-more-open");
    var servicesTrigger = servicesMenu.querySelector(".km-more-menu__trigger");
    if (servicesTrigger) servicesTrigger.setAttribute("aria-expanded", "false");
    var active = document.activeElement;
    if (active && active.closest(".km-more-menu") === servicesMenu) active.blur();

    if (
      header
      && !document.querySelector(".km-mega-open, .km-more-open, .km-submenu-open")
    ) {
      header.classList.remove("km-menu-active");
    }
  }, true);

  var bar = document.querySelector(".km-trust-bar");
  if (bar && window.ResizeObserver) {
    new ResizeObserver(syncAll).observe(bar);
  }

  if (header && window.MutationObserver) {
    new MutationObserver(syncHeaderControlsAppearance).observe(header, {
      childList: true,
      subtree: true,
    });
  }
})();
